import AsyncStorage from '@react-native-async-storage/async-storage';
import {APP_TYPE, clientConfigPathMaster} from '../../config/Constant';
import {
  hotelSelectorFailure,
  hotelSelectorRequest,
  hotelSelectorSuccess,
} from '../Reducers/hotelSelectorReducer';
 
 
let tradewinds_test_data = {
  payload: {
  data: [
    {
      "hotelList": [
        {
          "isBetaHotel": false,
          "hotelLogoImageUrl": "https://app.tradewindsresort.com:8443/cmsData/hoteligenceClient/mobileApp/hotel_images/IG_logo - BLUE 1.jpg",
          "hotelServerBaseUrl": "appig.tradewindsresort.com",
          "isProdHotel": true,
          "hotelMetaData": {},
          "hotelBannerImageUrl": "https://app.tradewindsresort.com:8443/cmsData/hoteligenceClient/mobileApp/hotel_images/thumb-island-grand.png%22",
          "displayOrder": 1,
          "hotelPropertyKey": "USTPATI",
          "isDisabled": false,
          "hotelIsAppSupported": true,
          "hotelName": "ISLAND GRAND",
          "sessionToken": "50820375-62fc-4234-b051-7aa64a8fae5c"
        },
        {
          "isBetaHotel": false,
          "hotelLogoImageUrl": "https://app.tradewindsresort.com:8443/cmsData/hoteligenceClient/mobileApp/hotel_images/RF_logo.jpg",
          "hotelServerBaseUrl": "apprf.tradewindsresort.com",
          "isProdHotel": true,
          "hotelMetaData": {},
          "hotelBannerImageUrl": "https://app.tradewindsresort.com:8443/cmsData/hoteligenceClient/mobileApp/hotel_images/hotelLogoRF.png%22",
          "displayOrder": 2,
          "hotelPropertyKey": "USTPATR",
          "isDisabled": false,
          "hotelIsAppSupported": true,
          "hotelName": "RUMFISH BEACH",
          "sessionToken": "a815485c-4bc2-4d27-9015-0220d6bdedb9"
        },
        {
          "isBetaHotel": false,
          "hotelLogoImageUrl": "https://app.tradewindsresort.com:8443/cmsData/hoteligenceClient/mobileApp/hotel_images/IG_logo - BLUE 1.jpg",
          "hotelServerBaseUrl": "appig.tradewindsresort.com",
          "isProdHotel": true,
          "hotelMetaData": {},
          "hotelBannerImageUrl": "https://app.tradewindsresort.com:8443/cmsData/hoteligenceClient/mobileApp/hotel_images/thumb-island-grand.png%22",
          "displayOrder": 5,
          "hotelPropertyKey": "USTPATI",
          "isDisabled": false,
          "hotelIsAppSupported": true,
          "hotelName": "RESORT PASS",
          "sessionToken": "50820375-62fc-4234-b051-7aa64a8fae5c"
        }
      ],
      "region": "United States",
      "order": 2
    }
  ]
}}
 
export const getHotelList = () => {
  return async dispatch => {
    dispatch(hotelSelectorRequest());
 
    let corporateSessionToken = await AsyncStorage.getItem('corporateSessionToken');
 
    const config = {
      headers: {
        Authorization: `Bearer ${corporateSessionToken}`,
      },
    };
    try {
      let response = await clientConfigPathMaster.get(
        `/multiHotelApp/hotels?appType=${APP_TYPE}`,
        config,
      );
      dispatch(hotelSelectorSuccess({hotelListData: tradewinds_test_data}));
    } catch (error) {
      dispatch(hotelSelectorSuccess({hotelListData: tradewinds_test_data}));
    }
  };
};